import { createActions, createReducer } from 'reduxsauce'

import moment from 'moment/moment'

import { momentBackDateTimeFormat } from '@smartcoop/utils/dates'

import { AuthenticationTypes } from '../authentication/duckAuthentication'


/* Initial State */
const INITIAL_STATE = {
  cropsUpdatedAt: null,
  bullUpdatedAt: null,
  milkDataUpdatedAt: moment().startOf('year').format(momentBackDateTimeFormat),
  productsUpdatedAt: null,
  productsLoading: false,
  milkDataLoading: false
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({

  setCropsUpdatedAt: ['cropsUpdatedAt'],

  setBullUpdatedAt: ['bullUpdatedAt'],

  setProductsUpdatedAt: ['productsUpdatedAt'],

  setProductsLoading: ['productsLoading'],

  setMilkDataLoading: ['milkDataLoading'],

  setMilkDataUpdatedAt: ['milkDataUpdatedAt'],

  syncError: ['error']
})

const setMilkDataUpdatedAt = (state = INITIAL_STATE, { milkDataUpdatedAt }) => ({
  ...state,
  error: INITIAL_STATE.error,
  milkDataUpdatedAt
})

const setProductsLoading = (state = INITIAL_STATE, { productsLoading }) => ({
  ...state,
  error: INITIAL_STATE.error,
  productsLoading
})

const setMilkDataLoading = (state = INITIAL_STATE, { milkDataLoading }) => ({
  ...state,
  error: INITIAL_STATE.error,
  milkDataLoading
})

const setCropsUpdatedAt = (state = INITIAL_STATE, { cropsUpdatedAt }) => ({
  ...state,
  error: INITIAL_STATE.error,
  cropsUpdatedAt
})

const setBullUpdatedAt = (state = INITIAL_STATE, { bullUpdatedAt }) => ({
  ...state,
  error: INITIAL_STATE.error,
  bullUpdatedAt
})

const setProductsUpdatedAt = (state = INITIAL_STATE, { productsUpdatedAt }) => ({
  ...state,
  error: INITIAL_STATE.error,
  productsUpdatedAt
})

const logout = () => ({ ...INITIAL_STATE })

/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.SET_MILK_DATA_UPDATED_AT]: setMilkDataUpdatedAt,

  [Types.SET_CROPS_UPDATED_AT]: setCropsUpdatedAt,

  [Types.SET_PRODUCTS_LOADING]: setProductsLoading,

  [Types.SET_MILK_DATA_LOADING]: setMilkDataLoading,

  [Types.SET_BULL_UPDATED_AT]: setBullUpdatedAt,

  [Types.SET_PRODUCTS_UPDATED_AT]: setProductsUpdatedAt,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as SyncTypes,
  Creators as SyncActions
}
